import { createSelector } from '@reduxjs/toolkit';

import { Inject } from '@vk-hr-tek/core/ioc';

import { RootState } from '@app/store';

import { ProcessCatalogMapper } from '../mappers';

export const selectCatalogCollectionsStatus = (state: RootState) =>
  state.processCatalog.collections.status;

export const selectCatalogCollectionsError = (state: RootState) =>
  state.processCatalog.collections.error;

export const selectCatalogCollections = createSelector(
  [
    (state: RootState) => state.processCatalog.collections.items,
    (_: RootState, inject: Inject) => inject(ProcessCatalogMapper),
  ],
  (collections, format) => {
    return format.processCatalogCollections(collections);
  },
);

export const selectSelectedCollection = (state: RootState) =>
  state.processCatalog.eventTypes.collection;

export const selectSelectedEventType = (state: RootState) =>
  state.processCatalog.eventTypes.selectedEventType;

export const selectCatalogEventTypesStatus = (state: RootState) =>
  state.processCatalog.eventTypes.status;

export const selectEventTypes = createSelector(
  (state: RootState) => state.processCatalog.eventTypes.items,
  (_: RootState, inject: Inject) => inject(ProcessCatalogMapper),
  (eventTypes, format) => {
    return format
      .processEventTypes(eventTypes)
      .filter((event) => !event.is_popular);
  },
);

export const selectPopularEventTypes = createSelector(
  (state: RootState) => state.processCatalog.eventTypes.items,
  (_: RootState, inject: Inject) => inject(ProcessCatalogMapper),
  (eventTypes, format) => {
    return format
      .processEventTypes(eventTypes)
      .filter((event) => event.is_popular);
  },
);
